/* @flow */

import { fetchJson } from 'utils/fetch';

export const fetchTemplates = (url: string) => fetchJson(url);



// WEBPACK FOOTER //
// ./src/modules/edito/api/index.js